import { createTheme } from '@mui/material';

const canvas = '#F5F7FA';
const line = '#E6EAEF';
const ink = '#172033';
const muted = '#667085';

const previewTheme = createTheme({
  palette: {
    primary: {
      main: '#0E6B62',
      dark: '#0A524B',
      light: '#E7F3F1',
      contrastText: '#FFFFFF',
    },
    text: {
      primary: ink,
      secondary: muted,
    },
    background: {
      default: canvas,
      paper: '#FFFFFF',
    },
    divider: line,
    error: {
      main: '#B42318',
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
    h1: {
      fontSize: '1.5rem',
      fontWeight: 600,
      letterSpacing: '-0.02em',
      lineHeight: 1.25,
    },
    subtitle1: {
      fontSize: '0.9375rem',
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
    caption: {
      fontSize: '0.75rem',
      letterSpacing: '0.04em',
      fontWeight: 600,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
      letterSpacing: 0,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: canvas,
          color: ink,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 600,
        },
        sizeMedium: {
          padding: '8px 14px',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        size: 'small',
        fullWidth: true,
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D8DEE6',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#B7C0CC',
          },
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: `1px solid ${line}`,
        },
      },
    },
  },
});

export default previewTheme;
